import { SelectionType } from "./document-self-assessment/useDocumentSelfAssessment";

export const useDocumentTokenSelector = (documentId: string) =>
  defineStore(`${documentId}/document/token-selector`, () => {
    const documentSelectionType = ref<SelectionType | undefined>();
    const documentSelectionCallback = ref<
      ((tokenGlobalPosition: number) => void) | undefined
    >();
    const selectedTokenPositions = ref<number[][]>([]);
    const hoveredTokenPositions = ref<number[]>([]);

    const isEditorFocused = ref(false);

    const setDocumentSelectionType = (
      type: SelectionType,
      callback: (tokenGlobalPosition: number) => void
    ) => {
      documentSelectionType.value = type;
      documentSelectionCallback.value = callback;
    };

    const clearDocumentSelectionType = () => {
      documentSelectionType.value = undefined;
      documentSelectionCallback.value = undefined;
      selectedTokenPositions.value = [];
      hoveredTokenPositions.value = [];
      hoveredRanges.value = [];
      hoveredRangeBoundaries.value = null;
      selectedRanges.value = [];
      selectedRangeBoundaries.value = null;
    };

    const mouseEnterTokens = (tokenPositions: number[]) => {
      hoveredTokenPositions.value = [
        ...hoveredTokenPositions.value,
        ...tokenPositions,
      ];
    };

    const mouseLeaveTokens = (tokenPositions: number[]) => {
      hoveredTokenPositions.value = hoveredTokenPositions.value.filter(
        (position) => !tokenPositions.includes(position)
      );
    };

    const addPositions = (tokenPositions: number[]) => {
      selectedTokenPositions.value = [
        ...selectedTokenPositions.value,
        tokenPositions,
      ];
    };

    const removePositions = (tokenPositions: number[]) => {
      selectedTokenPositions.value = selectedTokenPositions.value.filter(
        (positions) =>
          positions.every((position) => !tokenPositions.includes(position))
      );
    };

    const hoveredRanges = ref<any[][]>([]);
    const hoveredRangeBoundaries = ref<{ start: number; end: number } | null>(
      null
    );

    const addHoveredRanges = (
      ranges: any[],
      boundaries: { start: number; end: number }
    ) => {
      hoveredRanges.value = [...hoveredRanges.value, ranges];
      hoveredRangeBoundaries.value = boundaries;
    };

    const clearHoveredRanges = () => {
      hoveredRanges.value = [];
      hoveredRangeBoundaries.value = null;
    };

    const selectedRanges = ref<any[][]>([]);
    const selectedRangeBoundaries = ref<{ start: number; end: number } | null>(
      null
    );

    const addSelectedRanges = (
      ranges: any[],
      boundaries: { start: number; end: number }
    ) => {
      selectedRanges.value = [...selectedRanges.value, ranges];
      selectedRangeBoundaries.value = boundaries;
    };

    const clearSelectedRanges = () => {
      selectedRanges.value = [];
      selectedRangeBoundaries.value = null;
    };

    const scrollOffsetY = ref(0);
    const scrollOffsetX = ref(0);

    const setScrollOffsetY = (offset: number) => {
      scrollOffsetY.value = offset;
    };

    const setScrollOffsetX = (offset: number) => {
      scrollOffsetX.value = offset;
    };

    const lastHighlightRange = ref<{ start: number; end: number } | null>(null);

    return {
      documentSelectionType,
      documentSelectionCallback,
      setDocumentSelectionType,
      clearDocumentSelectionType,
      selectedTokenPositions,
      hoveredTokenPositions,
      addPositions,
      removePositions,
      mouseEnterTokens,
      mouseLeaveTokens,

      hoveredRanges,
      hoveredRangeBoundaries,
      addHoveredRanges,
      clearHoveredRanges,

      isEditorFocused,

      selectedRanges,
      selectedRangeBoundaries,
      addSelectedRanges,
      clearSelectedRanges,
      scrollOffsetY,
      scrollOffsetX,
      setScrollOffsetY,
      setScrollOffsetX,

      lastHighlightRange,
    };
  });
